import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { bindActionCreators } from "redux"
import { actionCreators } from "../../state"
import { euroQtyFormat, euroFormat, quantityFormat } from "../../utils"
import { DexxButton } from "../light/LightButton"
import Popup from "../Popup"
import { DexxNumericInput } from "../utils/Input"
import GenericPopup from "./GenericPopup"
import PopupRowData from "./utils/PopupRowData"
import PopupLabelAndValue from "./utils/PopupLabelAndValue"
import PopupDivider from "./utils/PopupDivider"

export default function AddLPPopup(props: { closeFunction: Function, uuidLP: string }): JSX.Element {

    //let uuid = props.uuidLP
    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)

    const [detailsLPRequest, setDetailsLPRequest] = useState()
    const [balance, setBalance] = useState<any>()

    const [uuid, setUuid] = useState<string>("")

    const [lpName, setLpName] = useState<string>("LP_")
    const [tokenA, setTokenA] = useState<string>("")
    const [tokenB, setTokenB] = useState<string>('XEUR')
    const [assetName, setAssetName] = useState<string>("")
    const [assetClass, setAssetClass] = useState<string>("")
    const [tokenAName, setTokenAName] = useState<string>("")
    const [tokenBName, setTokenBName] = useState<string>("")
    const [amountTokenB, setAmountTokenB] = useState<number>(0)
    const [maxTokenA, setMaxTokenA] = useState<number>(0)
    const [maxTokenB, setMaxTokenB] = useState<number>(0)
    const [lpAmountA, setLpAmountA] = useState<number>(0)
    const [lpAmountB, setLpAmountB] = useState<number>(0)
    const [getQuote, setGetQuote] = useState<boolean>(true)
    const [quote, setQuote] = useState<any>()
    const [spotPrice, setSpotPrice] = useState<number>(0)
    const [calcAmountTokenA, setCalcAmountTokenA] = useState<number>(0)
    const [calcAmountTokenB, setCalcAmountTokenB] = useState<number>(0.00)
    const [lpShares, setLpShares] = useState<number>(0)
    const [lpSharesPerc, setLpSharesPerc] = useState<number>(0)

    const [showPopUp, setShowPopUp] = useState<boolean>(false)
    const [titlePopUp, setTitlePopUp] = useState<string>("")
    const [msgPopUp, setMsgPopUp] = useState<string>("")
    const [request, setRequest] = useState<any>()

    useEffect(() => {
        setUuid(props.uuidLP)
    }, [props.uuidLP])


    useEffect(() => {
        if (uuid) actions.getDetailsLiquidityPool(uuid, setDetailsLPRequest)
        actions.getActualBalance(setBalance)
    }, [uuid])

    useEffect(() => {
        if (detailsLPRequest && detailsLPRequest[0] === 200) {
            let l: any = detailsLPRequest[1]
            setTokenAName(l.token_a_ticker)
            setTokenBName(l.token_b_ticker)
            setTokenA(l.token_a_uuid)
            setTokenB(l.token_b_uuid)
            setLpName(l.lp_name)
            setAssetName(l.asset_a_name)
            setLpAmountA(l.amount_a)
            setLpAmountB(l.amount_b)
            setAssetClass(l.asset_a_category)
        }
    }, [detailsLPRequest])

    useEffect(() => {
        if (getQuote && uuid !== "") {
            let r = {
                lp_uuid: uuid,
                token_a_uuid: tokenA,
                amount_a: 1,
                is_buy: true
            }
            actions.getLPQuote(r, setQuote)
            setGetQuote(false)
        }
    }, [getQuote, uuid, tokenA, props])

    useEffect(() => {
        if (quote) {
            if (quote[0] === 200) {
                let q = quote[1]
                let SP = Math.ceil(100 * q.lp_b / q.lp_a) / 100
                setSpotPrice(SP)

            } else {
                if (quote[0] === 500 && quote[1]) {
                    setTitlePopUp("Sorry!")
                    setMsgPopUp("We encountered an error providing a price quote.  Please try again.")
                    setShowPopUp(true)
                }
            }
        }
    }, [quote])

    useEffect(() => {
        if (balance && balance.payment_tokens) {
            setMaxTokenB(balance.payment_tokens.available_total)
        }

        if (balance && balance.balance.security_entries) {
            let tokensFromClass = balance.balance.security_entries.filter((c: any) => { return c.class === assetClass })
            if (tokensFromClass[0] && tokensFromClass[0].class_balance) {
                let actualToken = tokensFromClass[0].class_balance.filter((t: any) => { return t.token_uuid === tokenA })
                if (actualToken[0] && actualToken[0]?.available_quantity)
                    setMaxTokenA(actualToken[0]?.available_quantity)
            }
        }
    }, [balance, tokenA])

    useEffect(() => {
        if (request && request.length > 0) {
            if (request[0] === 200 || request[0] === 204) {
                setTitlePopUp("Success")
                setMsgPopUp("The operation has been completed successfully.")

                if (uuid) actions.getDetailsLiquidityPool(uuid, setDetailsLPRequest)
                actions.getActualBalance(setBalance)

            } else {
                setTitlePopUp("Sorry!")
                //setMsgPopUp(request && request[1] && request[1].error ? request[1].error : "There was an error while executing the request")
                setMsgPopUp("We encountered an error saving your data.")
            }
            setShowPopUp(true)
        }
    }, [request])

    useEffect(() => {
        if (amountTokenB !== 0 && spotPrice !== 0) {
            let sp = parseFloat(spotPrice.toString().replace(",", "."))
            let amountB = parseFloat(amountTokenB.toString().replace(",", "."))

            // if desired_euro_amount > euro_available ==> desired_euro_amount == euro_available (update field in popup)
            if (amountB > maxTokenB) setAmountTokenB(maxTokenB)

            // desired_tokens_amount == ROUNDDOWN( desired_euro_amount / desired_price ; 0 decimals ) //internal, not shown
            let fixedAmountA = sp > 0 ? parseInt(Math.floor(amountB / sp).toFixed(0)) : 0

            // if desired_tokens_amount > tokens_available ==> tokens_amount == tokens_available
            let amount = fixedAmountA < maxTokenA ? fixedAmountA : maxTokenA
            setCalcAmountTokenA((amount))

            // euro_amount == ROUND( tokens_amount * desired_price ; 2 decimals) //it's the same for both cases
            setCalcAmountTokenB(Math.floor((amount * sp * 100)) / 100)

        }
    }, [maxTokenA, amountTokenB, spotPrice, maxTokenB])

    function handleMax() {
        if (spotPrice && spotPrice !== 0) {
            let sp = parseFloat(spotPrice.toString().replace(",", "."))
            //When MAX is pressed, the calculation needs to take the min of both ways:

            // desired_euro_amount = ROUNDUP( tokens_available * desired_price ; 2 decimals )
            let fixedAmountB = Math.round(maxTokenA * sp * 100) / 100

            // if desired_euro_amount > euro_available ==> desired_euro_amount == euro_available
            if (fixedAmountB > maxTokenB) fixedAmountB = maxTokenB

            // update field desired_euro_amount
            setAmountTokenB(fixedAmountB)

            // tokens_amount == ROUNDDOWN( desired_euro_amount / desired_price ; 0 decimals )
            let fixedAmountA = Math.floor(parseInt((fixedAmountB / sp).toFixed(0)) * 100) / 100

            // update fields in box EFFECTIVE...
            setCalcAmountTokenA((fixedAmountA))
            setCalcAmountTokenA((Math.round((fixedAmountA * sp * 100)) / 100))
        } else {
            setTitlePopUp("Sorry!")
            setMsgPopUp("Spot price not defined")
            setShowPopUp(true)
        }
    }

    useEffect(() => {
        if (calcAmountTokenA !== 0 && calcAmountTokenB !== 0) {
            setLpShares(Math.floor((calcAmountTokenA) * (calcAmountTokenB)))
        }
    }, [calcAmountTokenA, calcAmountTokenB])

    useEffect(() => {
        if (detailsLPRequest && detailsLPRequest[0] === 200) {
            let l: any = detailsLPRequest[1]
            setLpSharesPerc(lpShares * 100 / (+l.lp_token_supply + +lpShares))
        }
    }, [lpShares])

    function handleSubmit() {
        let requestInfo = {
            lp_uuid: uuid,
            token_a: tokenA,
            amount_a: calcAmountTokenA,
            token_b: tokenB,
            max_amount_b: calcAmountTokenB.toString().replace(",", "."),
        }
        actions.addLiquidityPool(requestInfo, setRequest)
    }

    return <>
        <Popup show={showPopUp} title={titlePopUp} msg={msgPopUp} btnOk={true}
            close={() => { setShowPopUp(false); props.closeFunction() }} />
        <GenericPopup closeFunction={props.closeFunction} handleSubmit={handleSubmit} >
            <PopupRowData backgroundColor="succ1_lightest">
                <PopupLabelAndValue label="My Balance" />
                <PopupLabelAndValue label={tokenAName} value={quantityFormat(maxTokenA)} />
                <PopupLabelAndValue label={tokenBName} value={euroFormat(maxTokenB)} />
            </PopupRowData>
            <PopupDivider color="succ1" />
            <PopupRowData>
                <PopupLabelAndValue label="Asset Name:" value={assetName} />
                <PopupLabelAndValue label="Ticker:" value={tokenAName} />
                <PopupLabelAndValue label="Spot Price:" value={euroFormat(spotPrice)} />
            </PopupRowData>
            <PopupDivider color="succ1" />
            <PopupRowData>
                <PopupLabelAndValue label="Reserves of" value={lpName} />
                <PopupLabelAndValue label={tokenAName} value={lpAmountA} />
                <PopupLabelAndValue label={tokenBName} value={euroFormat(lpAmountB)} />
            </PopupRowData>
            <PopupDivider color="succ1" />
            <PopupRowData backgroundColor="succ1_lighter" nColumns="3">
                <PopupLabelAndValue label={"Desired " + tokenBName + " Amount *"} 
                    className="col-span-2" value={
                    <DexxNumericInput value={amountTokenB} className="text-sm font-bold" max={maxTokenB}
                        fun={(v: any) => setAmountTokenB((v ? v : "0"))} />} />
                <div className="flex items-end">
                    <DexxButton label={"MAX"} className="px-4 rounded-lg font-normal mt-1 py-0"
                        fontClasses="text-xs"
                        color1="primary" color2="primary" color3="primary_lightest"
                        onClick={() => {
                            handleMax()
                        }} />
                </div>

            </PopupRowData>
            <PopupDivider color="succ1" />
            <PopupRowData>
                <PopupLabelAndValue label="Reserves to add" />
                <PopupLabelAndValue label={tokenAName} value={euroQtyFormat(calcAmountTokenA)} />
                <PopupLabelAndValue label={tokenBName} value={euroFormat(calcAmountTokenB)} />
            </PopupRowData>
            <PopupDivider color="succ1" />
            <PopupRowData nColumns="1" className="text-sm font-normal mb-4">
                <div className="font-medium text-succ1">Review</div>
                <div>Effective {tokenAName}:
                    <strong>{euroQtyFormat(calcAmountTokenA)}</strong>
                </div>
                <div>Effective {tokenBName}:
                    <strong>{euroFormat(calcAmountTokenB)}</strong>
                </div>
                <div>LP shares to receive:
                    <strong>{euroQtyFormat(lpShares) + " (" + euroFormat(lpSharesPerc) + "%)"}</strong>
                </div>
            </PopupRowData>
        </GenericPopup>
    </>
}